// Extend the Window interface to recognize dataLayer
declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}
interface GTMEvent {
  event: string;
  "gtm.element": string; // The name of the event
  "gtm.elementTarget": string; // The event description
  Status: any;
  "Click Text": string;
}

export const pushManualGTMEvent = (
  eventName: string,
  eventValue: string,
  data = {}
) => {
  try {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || []; // Ensure dataLayer exists
      window.dataLayer.push({
        event: eventName,
        Status: eventValue, // Custom event name,
        ...data,
      } as GTMEvent);
    }
  } catch (e) {
    console.error("Error logging GTM event", e);
  }
};

interface GTMClickEvent {
  event: "gtm.click";
  "gtm.element": string; // The clicked element's selector or ID
  "gtm.elementClasses"?: string; // Optional: Element classes
  "gtm.elementId"?: string; // Optional: Element ID
  "gtm.elementTarget"?: string; // Optional: Button text or target name
  [key: string]: any;
}

export const pushGTMClickEvent = (
  element: HTMLElement,
  customEvents: Record<string, any> = {}
) => {
  try {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || []; // Ensure dataLayer exists
      window.dataLayer.push({
        event: "gtm.click",
        "gtm.element": element.tagName.toLowerCase(),
        "gtm.elementClasses": element.className || undefined,
        "gtm.elementId": element.id || undefined,
        "gtm.elementTarget": element.textContent?.trim() || undefined,
        ...customEvents,
      } as GTMClickEvent);
    }
  } catch (e) {
    console.error("Error logging GTM click event", e);
  }
};
